<template>
    <!--  /.menu  -->
    <div id="home-slider" class="carousel slide carousel-fade" data-ride="carousel">
        <!-- .home-slider -->
        <div class="carousel-inner">

            <div class="item active"
                 style="background-image: url('https://img.hogonmr.cn/cover/39.png?imageView2/0/w/700');  background-repeat: no-repeat; background-position: right top;background-color: #F6F6F6;">
                <div class="caption">
                    <h2 class="animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">HM WHITE<br>
                        时尚铆钉休闲鞋</h2>
                    <p class="animated wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">Lucile Mendez 向经典休闲鞋汲取灵感，为霍根先生呈献HM WHITE钉休闲鞋，成就鞋履系列的新经典。意大利头层小牛皮制作，鞋面需要品牌工匠耗时7小时方可完成。</p>
                    <a data-scroll class="btn get-start animated fadeInUpBig" href="#">
                        <router-link to="/goods?id=39"><span>查看更多</span></router-link>
                    </a></div>
            </div>


            <div class="item"
                 style="background-image: url(https://img.hogonmr.cn/product/_MG_9232.jpg?imageView2/0/w/700);  background-repeat: no-repeat; background-position: right top;background-color: #F6F6F6;">
                <div class="caption">
                    <h2 class="animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">HM WHITE<br> 休闲运动鞋
                    </h2>
                    <p class="animated wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">Lucile Mendez
                        向经典休闲鞋汲取灵感，为霍根先生呈现HM WHITE 体闲远动鞋，成就鞋品系列的新经典，意大利头层小牛皮制作，鞋面需要需要品牌工匠耗时7小时方可完成。 </p>
                    <a data-scroll class="btn get-start animated fadeInUpBig" href="#">
                        <router-link to="/goods?id=34"><span>查看更多</span></router-link>
                    </a></div>
            </div>


            <div class="item"
                 style="background-image: url(https://img.hogonmr.cn/product/IMG4_3316.jpg?imageView2/0/w/700);  background-repeat: no-repeat; background-position: right top;background-color: #F6F6F6;">
                <div class="caption">
                    <h2 class="animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">HM<br> C字母棒球帽</h2>
                    <p class="animated wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                        经典棒球帽前弯帽檐设计，正面刺绣品牌标识，搭配哑光细节和后部的可调节饰带，与同系列单品搭配相宜，包括腰带和皮具。</p>
                    <a data-scroll class="btn get-start animated fadeInUpBig" href="#">
                        <router-link to="/goods?id=4"><span>查看更多</span></router-link>
                    </a></div>
            </div>

            <!-- indicators -->
            <ol class="carousel-indicators">
                <li data-target="#home-slider" data-slide-to="0" class="active"></li>
                <li data-target="#home-slider" data-slide-to="1" class=""></li>
                <li data-target="#home-slider" data-slide-to="2" class=""></li>
            </ol>
            <!-- /indicators -->
        </div>
        <!-- /.home-slider -->
    </div>

    <section class="banner-outer">
        <!-- .banner-outer -->
        <div class="container">
            <!-- .banner-bg -->
<!--            <div class="banner-bg">-->
<!--                <div class="col-sm-4 col-md-4">-->
<!--                    &lt;!&ndash; .banner-img &ndash;&gt;-->
<!--                    <router-link to="/goods?id=45">-->
<!--                        <div class="banner-img animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s" style="background: #F5F5F5;padding-bottom: 20px;height:150px;">-->
<!--                            <img src="https://img.hogonmr.cn/cover/45.png?imageView2/0/w/250" alt="about-img1" style="padding-left:200px;" />-->
<!--                            <div class="banner-text">-->
<!--                                <h3>Forrest Gump<br/>时尚蓝标板鞋</h3>-->
<!--                                <p class="price">¥6,800</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                    &lt;!&ndash; /.banner-outer &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="col-sm-4 col-md-4">-->
<!--                    &lt;!&ndash; .banner-img &ndash;&gt;-->
<!--                    <router-link to="/goods?id=43">-->
<!--                        <div class="banner-img animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s" style="background: #F5F5F5;padding-bottom: 20px;height:150px;">-->
<!--                            <img src="https://img.hogonmr.cn/cover/43.png?imageView2/0/w/250" alt="about-img1" style="padding-left:200px;" />-->
<!--                            <div class="banner-text">-->
<!--                                <h3>HM WHITE<br/>休闲小白鞋</h3>-->
<!--                                <p class="price">¥6,300</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                    &lt;!&ndash; /.banner-outer &ndash;&gt;-->
<!--                </div>-->
<!--                <div class="col-sm-4 col-md-4">-->
<!--                    &lt;!&ndash; .banner-img &ndash;&gt;-->
<!--                    <router-link to="/goods?id=44">-->
<!--                        <div class="banner-img  animated wow zoomIn"  data-wow-duration=".5s" data-wow-delay=".2s" style="background: #F5F5F5;padding-bottom: 20px;height:150px;">-->
<!--                            <img src="https://img.hogonmr.cn/cover/44.png?imageView2/0/w/250" alt="about-img1" style="padding-left:200px;" />-->
<!--                            <div class="banner-text">-->
<!--                                <h3>HM 经典<br/>立体虎头图案 T 恤</h3>-->
<!--                                <p class="price">¥2,680</p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </router-link>-->
<!--                    &lt;!&ndash; /.banner-outer &ndash;&gt;-->
<!--                </div>-->
<!--            </div>-->
            <!-- /.banner-bg -->
        </div>
        <!-- /.banner -->
    </section>


    <section class="trending-products">
        <!-- .trending-products -->
        <div class="container">
            <div class="tittle text-center">
                <h2>SHOW 春夏系列</h2>
                <p>HOGON MR 服装艺术总监 Katharine Hayes 推出 春夏系列，以绚烂色彩背景彰显年轻时尚活力氛围。</p>
            </div>

            <div class="col-lg-6">
                <div class="row animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">
                    <div class="col-md-6">
                        <router-link to="/goods?id=50">
                            <!-- .pro-text -->
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/cover/50.png?imageView2/0/w/400" alt="2"/>

                                </div>
                                <!-- /.pro-img --><a href="#">HM CARTOON 立体鱼骨图案 T 恤</a> <a href="#"
                                                                                                class="addtocart">+
                                加入购物车</a>
                                <div class="price">¥2,680</div>
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                    <div class="col-md-6">
                        <!-- .pro-text -->
                        <router-link to="/goods?id=41">
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/cover/41.png?imageView2/0/w/400" alt="2"/>
                                    <!-- .hover-img -->
                                    <div class="hover-img">
                                        <ul>
                                            <li><a href="#"><i class="fa fa-heart-o" aria-hidden="true"></i></a></li>
                                            <li><a href="#"><i class="fa fa-sliders" aria-hidden="true"></i></a></li>
                                            <li><a href="#" data-toggle="modal" data-target="#quickModal"
                                                   data-whatever="@mdo"><i class="fa fa-search" aria-hidden="true"></i></a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="new tage"><span class="new-text">NEW</span> <span
                                            class="pres-text">-15%</span></div>
                                    <!-- /.hover-img -->
                                </div>
                                <!-- /.pro-img --><a href="#">HM CARTOON H字母图案 T 恤</a> <a href="#"
                                                                                              class="addtocart">+
                                加入购物车</a>
                                <div class="price">¥2,480</div>
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                    <div class="col-md-12">
                        <!-- .pro-text -->
                        <router-link to="/goods?id=48">
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img"><img src="https://img.hogonmr.cn/cover/48.png?imageView2/0/w/700" alt="2"/>
                                    <div class="pro-img-text">
                                        <a href="#">
                                            <h4>HM 立体虎头图案 T 恤</h4>
                                        </a>
                                        <div class="price">¥2,680</div>
                                    </div>
                                </div>
                                <!-- /.pro-img -->
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="row animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">
                    <div class="col-md-12">
                        <router-link to="/goods?id=39">
                            <!-- .pro-text -->
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img"><img src="https://img.hogonmr.cn/cover/39.png?imageView2/0/w/700" alt="2"/>
                                    <div class="pro-img-text">
                                        <a href="#">
                                            <h4>HM 时尚铆钉休闲鞋</h4>
                                        </a>
                                        <div class="price">¥6,980</div>
                                    </div>
                                </div>
                                <!-- /.pro-img -->
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/goods?id=4">
                            <!-- .pro-text -->
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/home/05.png?imageView2/0/w/400" alt="2"/>

                                </div>
                                <!-- /.pro-img --><a href="#">HM C 字母棒球帽</a> <a href="#" class="addtocart">+
                                加入购物车</a>
                                <div class="price">¥599</div>
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                    <div class="col-md-6">
                        <router-link to="/goods?id=47">
                            <!-- .pro-text -->
                            <div class="pro-text">
                                <!-- .pro-img -->
                                <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/cover/47.png?imageView2/0/w/400" alt="2"/>

                                </div>
                                <!-- /.pro-img --><a href="#">HM  时尚经典珠光银色休闲鞋</a> <a href="#" class="addtocart">+
                                加入购物车</a>
                                <div class="price">¥6,300</div>
                            </div>
                            <!-- /.pro-text -->
                        </router-link>
                    </div>
                </div>
            </div>

        </div>
        <!-- /.trending-products -->
    </section>

    <section class="banner-outer">
        <!-- .banner-outer -->
        <div class="col-sm-6 col-md-6">
            <router-link to="/goods?id=46">
                <!-- .banner-img -->
                <div class="banner-img" style="background: #F5F5F5;">
                    <img src="https://img.hogonmr.cn/cover/46.png?imageView2/0/w/550" alt="about-img1"
                         style="padding-left:360px;"/>
                    <div class="banner-text2">
                        <h4>2023春夏</h4>
                        <h3>H字母卡通图案 T 恤</h3>
                        <p>本款T恤以元素点明HOGON MR的经典笔触辨识度极高的虎头图案将品牌标识融入胸前印花，趣味演绎年轻时尚。舒软棉质针织适宜日常穿着。</p>
                        <p><a href="#">立即购买 / <span class="price">¥2,680</span></a></p>
                    </div>
                </div>
                <!-- /.banner-outer -->
            </router-link>
        </div>

        <div class="col-sm-6 col-md-6">
            <router-link to="/goods?id=45">
                <!-- .banner-img -->
                <div class="banner-img" style="background: #F5F5F5;">
                    <img src="https://img.hogonmr.cn/cover/45.png?imageView2/0/w/550" alt="about-img1"
                         style="padding-left:360px;"/>
                    <div class="banner-text2">
                        <h4>Forrest Gump</h4>
                        <h3>时尚蓝标板鞋</h3>
                        <p>Lucile Mendez 向经典休闲鞋汲取灵感，为霍根先生呈献Forrest Gump休闲运动鞋，成就鞋履系列的新经典。意大利头层小牛皮制作，鞋面需要品牌工匠耗时7小时方可完成。</p>
                        <p><a href="#">立即购买 / <span class="price">¥6,800</span></a></p>
                    </div>
                </div>
                <!-- /.banner-outer -->
            </router-link>
        </div>
        <!-- /.banner -->
    </section>


    <section class="new-arrivals">
        <!-- .new-arrivals -->
        <div class="container">
            <div class="tittle text-center">
                <h2>夏日星辰系列</h2>
                <p>夏季系列自炎炎夏日与温暖星空汲取设计灵感，造型轻盈流畅，采用点点繁星印花和柔和彩虹色调，是度假休闲的不二之选。</p>
            </div>

            <div class="row animated wow zoomIn" data-wow-duration=".5s" data-wow-delay=".2s">
                <div class="col-5">
                    <router-link to="/goods?id=1">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img  goods-pd"><img src="https://img.hogonmr.cn/product/0101.jpg?imageView2/0/w/400"
                                                      alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">MINI TCOS<br/>
                            锁头手提包</a> <a href="#" class="addtocart">+ 加入购物车</a>
                            <div class="price">¥2,680 <span>¥5,700</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link to="/goods?id=6">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img  goods-pd"><img src="https://img.hogonmr.cn/product/0H0A3231.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="discount tage"> <span class="discount-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM<br/>束脚休闲裤</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥2,280 <span>¥4,800</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link to="/goods?id=5">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img  goods-pd"><img src="https://img.hogonmr.cn/home/07.png?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->


                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM <br/>字母鸭舌帽</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥599 <span>¥999</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link to="/goods?id=26">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img   goods-pd"><img src="https://img.hogonmr.cn/product/0H0A3050.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM<br/>可爱呆萌脸 T 恤</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥2,200 <span>¥3,900</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>
                <div class="col-5">
                    <router-link to="/goods?id=26">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img  goods-pd"><img src="https://img.hogonmr.cn/product/0H0A3148.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">夏「TIGER」<br/>立体虎头图案 T 恤</a> <a href="#"
                                                                                              class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥2,200 <span>¥4,360</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>

                <div class="col-5">
                    <router-link to="/goods?id=11">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/home/08.png?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM CARTOON<br/>油蜡老虎图案 T 恤</a> <a href="#"
                                                                                                class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥1,980 <span>¥3,900</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>

                <div class="col-5">
                    <router-link to="/goods?id=36">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/product/IMG_2276.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">Forrest Gump<br/>阿甘休闲运动鞋</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥5,900 <span>¥7,900</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>

                <div class="col-5">
                    <router-link to="/goods?id=9">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/product/0H0A3206.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM<br/>运动打底裤</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥1,280 <span>¥3,900</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>

                <div class="col-5">
                    <router-link to="/goods?id=34">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/home/09.png?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM HIGH <br/>增高休闲鞋</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥7,800 <span>¥1,2580</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>


                <div class="col-5">
                    <router-link to="/goods?id=14">
                        <!-- .pro-text -->
                        <div class="pro-text">
                            <!-- .pro-img -->
                            <div class="pro-img goods-pd"><img src="https://img.hogonmr.cn/product/_MG_3228.jpg?imageView2/0/w/400" alt="2"/>
                                <!-- .hover-img -->

                                <!--                            <div class="new tage"> <span class="new-text">NEW</span> <span class="pres-text">-15%</span> </div>-->
                                <!-- /.hover-img -->
                            </div>
                            <!-- /.pro-img --><a href="#">HM 经典<br/>条纹小熊图案 T 恤</a> <a href="#" class="addtocart">+
                            加入购物车</a>
                            <div class="price">¥2,280 <span>¥4,999</span></div>
                        </div>
                        <!-- /.pro-text -->
                    </router-link>
                </div>

            </div>
        </div>
        <!-- /.new-arrivals -->
    </section>


    <section class="section-padding">
        <div class="container">
            <div class="tittle text-center">
                <h2>我们的品牌历程</h2>
                <p>HOGON MR 1990年起源于意大利，创始人霍根先生随性别致的独特理念是对时尚生活方式的完美诠释。</p>
            </div>
            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home5.png?imageView2/0/w/400" alt="news-img1"/>
                    </div>
                    <div class="news-text"><a href="#nogo">HOGON MR 意大利米兰专卖店成立</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> HOGON MR 1990年起源于意大利，创始人霍根先生随性别致的独特理念是对时尚生活方式的完美诠释。</div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".2s" data-wow-delay=".1s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home6.png?imageView2/0/w/400" alt="news-img2"/>
                    </div>
                    <div class="news-text"><a href="#nogo">巴黎·HOGON MR第一家海外专卖店</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> 1998年秋冬，巴黎第一家HOGON MR海外专卖店正式成立，标志着HOGON MR品牌全球扩张的第一步。</div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".4s" data-wow-delay=".3s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home1.png?imageView2/0/w/400" alt="news-img3"/>
                    </div>
                    <div class="news-text"><a href="#nogo">HOGON MR 中东地区·沙特专卖店成立</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> 2007年9月，沙特，第一家中东地区HOGON MR专卖店成立，继续细分国际市场。
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".4s" data-wow-delay=".3s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home2.png?imageView2/0/w/400" alt="news-img4"/>
                    </div>
                    <div class="news-text"><a href="#nogo">HOGON MR ·中国广州品牌旗舰店成立</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> 2013年，中国广州荔湾区1000平米的HOGON MR品牌旗舰店正式开业，开业状况盛大空前。</div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".4s" data-wow-delay=".3s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home4.png?imageView2/0/w/400" alt="news-img5"/>
                    </div>
                    <div class="news-text"><a href="#nogo">印度尼西亚·HOGON MR 专卖店成立</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> 2020年7月，印度尼西亚sogo百货，开设4家HOGON MR专卖店。</div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>
            <div class="col-sm-4 col-md-4 wow fadeIn" data-wow-duration=".4s" data-wow-delay=".3s">
                <div class="news-box">
                    <div class="news-img">
                        <img src="https://img.hogonmr.cn/news/home3.png?imageView2/0/w/400" alt="news-img6"/>
                    </div>
                    <div class="news-text"><a href="#nogo">HOGON MR 参加德国DOSELDUF时装展</a>
                        <p>来自 <span>azero</span> / 2019年12月</p>
                        <div class="news-text-content"> 2020年11月，HOGON MR品牌参加德国DOSELDUF时装展，并发布2021秋冬新品。</div>
                        <router-link to="/news"><a href="#nogo" class="readbtn">阅读更多</a></router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {}
</script>
<style scoped>
    .goods-pd{
        padding: 30px 0px;
        background: #F5F5F5;
    }
</style>